import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.rawdata.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

declare const wiz: any;

@Component({
    selector: 'wiz-portal-rawdata-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.rawdata.list/view.scss */
.grid-cols-16 {
  grid-template-columns: repeat(16, minmax(0, 1fr));
}

.grid-cols-14 {
  grid-template-columns: repeat(14, minmax(0, 1fr));
}

.grid-cols-13 {
  grid-template-columns: repeat(13, minmax(0, 1fr));
}`],
})
export class PortalRawdataListComponent implements OnInit {
    // 데이터셋 목록
    public items: any[] = [];

    // 데이터셋 요약 정보 (Milvus / 파일 개수 등)
    public datasetSummaryMap: { [name: string]: any } = {};
    public datasetSummaryLoading: { [name: string]: boolean } = {};
    public datasetSummaryError: { [name: string]: string } = {};
    public openedDataset: string | null = null;

    // 생성 모달 상태
    public showMkdirModal: boolean = false;
    public mkdirName: string = '';
    public mkdirError: string = '';

    // 이름 수정 모달 상태
    public showRenameModal: boolean = false;
    public renameTarget: any = null;
    public renameName: string = '';
    public renameError: string = '';

    // 로딩/에러
    public loading: boolean = false;
    public error: string = '';
    public ocrProcessing: boolean = false;
    public embeddingProcessing: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();

        // 1) 데이터셋 목록 로드
        await this.loadRoot();

        // 2) 각 데이터셋의 요약 정보를 별도 함수에서 미리 로드
        await this.preloadDatasetSummaries();

        await this.service.render();
    }

    // 루트(/) 데이터셋 목록 불러오기
    public async loadRoot() {
        this.loading = true;
        this.error = '';
        this.service.render();

        try {
            const res: any = await wiz.call('browse', { cwd: '/' });
            const data = res?.data || {};
            const rawItems = data.items || [];

            // 기존 요약/에러/로딩 정보 초기화
            this.datasetSummaryMap = {};
            this.datasetSummaryLoading = {};
            this.datasetSummaryError = {};
            this.openedDataset = null;

            this.items = rawItems.map((it: any) => ({
                ...it,
                checked: false
            }));
        } catch (e) {
            console.error('[rawdata-list] loadRoot error:', e);
            this.error = '데이터셋 목록을 불러오는 중 오류가 발생했습니다.';
        }

        this.loading = false;
        this.service.render();
    }

    // 목록 로드 이후, 각 데이터셋의 요약 정보를 한 번에 불러오는 함수
    private async preloadDatasetSummaries() {
        if (!this.items || this.items.length === 0) return;

        // 로딩 플래그 세팅
        for (const it of this.items) {
            const name = it?.name;
            if (!name) continue;
            this.datasetSummaryLoading[name] = true;
            this.datasetSummaryError[name] = '';
        }
        this.service.render();

        // 각 데이터셋에 대해 요약 정보 조회
        for (const it of this.items) {
            const name = it?.name;
            if (!name) continue;

            try {
                const res: any = await wiz.call('get_dataset_summary', { name });

                if (res && res.code === 200) {
                    let payload = res.data?.data || res.data || null;

                    if (payload) {
                        this.datasetSummaryMap[name] = payload;
                        this.datasetSummaryError[name] = '';
                    } else {
                        this.datasetSummaryMap[name] = null;
                        this.datasetSummaryError[name] = '요약 정보를 가져오지 못했습니다.';
                    }
                } else {
                    this.datasetSummaryMap[name] = null;
                    this.datasetSummaryError[name] = res?.data?.error || '요약 정보를 가져오지 못했습니다.';
                }
            } catch (e) {
                console.error('[rawdata-list] get_dataset_summary error:', e);
                this.datasetSummaryMap[name] = null;
                this.datasetSummaryError[name] = '요약 정보를 가져오는 중 오류가 발생했습니다.';
            } finally {
                this.datasetSummaryLoading[name] = false;
            }
        }
        this.service.render();
    }

    // 데이터셋 상세 화면으로 이동 (/ui/rawdata/:id)
    public openDataset(id: string) {
        this.router.navigateByUrl(`/ui/rawdata/${id}`);
    }

    // 체크박스 변경 시
    public onCheckedChange() {
        this.service.render();
    }

    // 하나라도 체크되어 있으면 삭제 버튼 활성화
    public canDeleteDatasets(): boolean {
        return this.items.some(it => it.checked);
    }
    
    // 전체 선택 여부 확인
    public get isAllSelected(): boolean {
        if (!this.items || this.items.length === 0) return false;
        return this.items.every(it => it.checked === true);
    }
    
    // 전체 선택 토글
    public toggleSelectAll() {
        const shouldCheck = !this.isAllSelected;
        this.items.forEach(it => it.checked = shouldCheck);
        this.service.render();
    }
    
    // 데이터셋 삭제
    public async deleteDatasets() {
        const selected = this.items.filter(it => it.checked).map(it => it.name);

        if (selected.length === 0) {
            alert('삭제할 데이터셋을 선택해 주세요.');
            return;
        }

        if (!confirm('선택한 데이터셋을 삭제하시겠습니까?\n연결된 스토리지와 벡터 컬렉션도 함께 삭제됩니다.')) {
            return;
        }

        const params = new URLSearchParams({
            datasets: JSON.stringify(selected)
        }).toString();

        try {
            const res: any = await wiz.call('delete_dataset?' + params);

            if (res && res.code === 200) {
                alert('삭제가 완료되었습니다.');
                window.location.reload();
            } else {
                alert(res?.data?.error || '삭제 중 오류가 발생했습니다.');
            }
        } catch (e) {
            console.error('[rawdata-list] deleteDatasets error:', e);
            alert('삭제 중 오류가 발생했습니다.');
        }
    }

    // 생성 모달 열기
    public openMkdir() {
        this.mkdirName = '';
        this.mkdirError = '';
        this.showMkdirModal = true;
        this.service.render();
    }

    // 생성 모달 닫기
    public closeMkdir() {
        this.showMkdirModal = false;
        this.mkdirError = '';
        this.mkdirName = '';
        this.service.render();
    }

    // 데이터셋 생성 확정
    public async confirmMkdir() {
        const name = (this.mkdirName || '').trim();

        if (!name) {
            this.mkdirError = '데이터셋 이름을 입력해 주세요.';
            this.service.render();
            return;
        }

        if (name.includes('/') || name.includes('\\')) {
            this.mkdirError = '데이터셋 이름에 경로 구분자를 포함할 수 없습니다.';
            this.service.render();
            return;
        }

        try {
            const res: any = await wiz.call('create_dataset', { name });

            if (res && res.code === 200) {
                this.closeMkdir();
                await this.loadRoot();
                await this.preloadDatasetSummaries();
            } else {
                this.mkdirError = res?.data?.error || '데이터셋 생성에 실패했습니다.';
                this.service.render();
            }
        } catch (e) {
            console.error('[rawdata-list] create_dataset error:', e);
            this.mkdirError = '데이터셋 생성 중 오류가 발생했습니다.';
            this.service.render();
        }
    }

    // 시간 포맷
    public formatTime(ts: number): string {
        if (!ts) return '-';
        const d = new Date(ts * 1000);
        const y = d.getFullYear();
        const m = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        const hh = d.getHours().toString().padStart(2, '0');
        const mm = d.getMinutes().toString().padStart(2, '0');
        return `${y}-${m}-${day} ${hh}:${mm}`;
    }

    // 데이터셋 상세 토글
    public async toggleDatasetDetail(it: any, event: MouseEvent) {
        event.stopPropagation();

        const name = it?.name;
        if (!name) return;

        this.openedDataset = this.openedDataset === name ? null : name;
        this.service.render();
    }

    // 벡터 DB 삽입 가능 여부 
    canRunVectorInsert(): boolean {
        const selected = this.items.filter(it => it.checked);
        if (selected.length === 0) return false;

        return selected.every(it => {
            const summary = this.datasetSummaryMap[it.name];
            if (!summary) return false;
            if (summary.ocr_files === 0) return false;
            return (
                summary.embedding_files > 0
                // summary.total_files > 0 &&
                // summary.ocr_files === summary.total_files &&
                // summary.embedding_files === summary.total_files
            );
        });
    }

    // OCR 처리 가능 여부
    canRunOcr(): boolean {
        if (this.ocrProcessing) return false;
        const selected = this.items.filter(it => it.checked);
        return selected.length > 0;
    }

    // 임베딩 처리 가능 여부
    canRunEmbedding(): boolean {
        if (this.embeddingProcessing) return false;
        const selected = this.items.filter(it => it.checked);
        if (selected.length === 0) return false;

        return selected.every(it => {
            const summary = this.datasetSummaryMap[it.name];
            if (!summary) return false;
            return (summary.ocr_files || 0) > 0;
        });
    }


    // 벡터 DB 삽입
    async activeVectorDBInsert() {
        const datasets = this.items
            .filter(it => it.checked)
            .map(it => it.name);

        if (datasets.length === 0) {
            alert('벡터DB에 삽입할 데이터셋을 선택해 주세요.');
            return;
        }

        if (!confirm(
            '선택한 데이터셋의 벡터 컬렉션을 새로 생성합니다.\n' +
            '기존 벡터 데이터는 모두 삭제되고 다시 삽입됩니다.\n\n' +
            '계속 진행하시겠습니까?'
        )) return;

        const params = new URLSearchParams({
            datasets: JSON.stringify(datasets)
        }).toString();

        const res = await wiz.call('insert_dataset_to_milvus?' + params);

        if (res?.code === 200) {
            alert('벡터DB 삽입이 완료되었습니다.');
            window.location.reload();
        } else {
            alert(res?.error || '벡터DB 삽입 중 오류가 발생했습니다.');
        }
    }


    // OCR 처리
    async activeOcr() {
        if (this.ocrProcessing) return;
        const datasets = this.items
            .filter(it => it.checked)
            .map(it => it.name);

        if (datasets.length === 0) {
            alert('OCR 처리할 데이터셋을 선택해 주세요.');
            return;
        }

        if (!confirm(
            '선택한 데이터셋의 모든 하위 폴더까지 OCR을 처리합니다.\n' +
            '이미 처리된 파일은 기본적으로 건너뜁니다.\n\n' +
            '계속 진행하시겠습니까?'
        )) return;

        const params = new URLSearchParams({
            datasets: JSON.stringify(datasets)
        }).toString();

        try {
            this.ocrProcessing = true;
            this.service.render();
            const res: any = await wiz.call('run_dataset_ocr?' + params);

            if (res?.code === 200) {
                alert('OCR 처리가 완료되었습니다.');
                await this.loadRoot();
                await this.preloadDatasetSummaries();
            } else {
                alert(res?.data?.error || 'OCR 처리 중 오류가 발생했습니다.');
            }
        } catch (e) {
            console.error('[rawdata-list] run_dataset_ocr error:', e);
            alert('OCR 처리 중 오류가 발생했습니다.');
        } finally {
            this.ocrProcessing = false;
            this.service.render();
        }
    }


    // 임베딩 처리
    async activeEmbedding() {
        if (this.embeddingProcessing) return;
        const datasets = this.items
            .filter(it => it.checked)
            .map(it => it.name);

        if (datasets.length === 0) {
            alert('임베딩 처리할 데이터셋을 선택해 주세요.');
            return;
        }

        if (!confirm(
            '선택한 데이터셋의 모든 하위 폴더까지 임베딩을 처리합니다.\n' +
            '이미 처리된 파일은 기본적으로 건너뜁니다.\n\n' +
            '계속 진행하시겠습니까?'
        )) return;

        const params = new URLSearchParams({
            datasets: JSON.stringify(datasets)
        }).toString();

        try {
            this.embeddingProcessing = true;
            this.service.render();
            const res: any = await wiz.call('run_dataset_embedding?' + params);

            if (res?.code === 200) {
                alert('임베딩 처리가 완료되었습니다.');
                await this.loadRoot();
                await this.preloadDatasetSummaries();
            } else {
                alert(res?.data?.error || '임베딩 처리 중 오류가 발생했습니다.');
            }
        } catch (e) {
            console.error('[rawdata-list] run_dataset_embedding error:', e);
            alert('임베딩 처리 중 오류가 발생했습니다.');
        } finally {
            this.embeddingProcessing = false;
            this.service.render();
        }
    }


    // 이름 수정 모달 열기
    public openRename(item: any, event: MouseEvent) {
        event.stopPropagation();
        this.renameTarget = item;
        this.renameName = item.name;
        this.renameError = '';
        this.showRenameModal = true;
        this.service.render();
    }

    // 이름 수정 모달 닫기
    public closeRename() {
        this.showRenameModal = false;
        this.renameTarget = null;
        this.renameName = '';
        this.renameError = '';
        this.service.render();
    }

    // 이름 수정 확정
    public async confirmRename() {
        const newName = (this.renameName || '').trim();

        if (!newName) {
            this.renameError = '새 이름을 입력해 주세요.';
            this.service.render();
            return;
        }

        if (newName === this.renameTarget.name) {
            this.closeRename();
            return;
        }

        if (newName.includes('/') || newName.includes('\\')) {
            this.renameError = '이름에 경로 구분자를 포함할 수 없습니다.';
            this.service.render();
            return;
        }

        try {
            const res: any = await wiz.call('rename_dataset', {
                old_name: this.renameTarget.name,
                new_name: newName
            });

            if (res && res.code === 200) {
                this.closeRename();
                await this.loadRoot();
                await this.preloadDatasetSummaries();
            } else {
                this.renameError = res?.data?.error || '이름 변경에 실패했습니다.';
                this.service.render();
            }
        } catch (e) {
            console.error('[rawdata-list] rename_dataset error:', e);
            this.renameError = '이름 변경 중 오류가 발생했습니다.';
            this.service.render();
        }
    }
}

export default PortalRawdataListComponent;